import {Artist} from "../utils/artist.utils";

const ROUTE_PATHS = {
  HOME: "/",
  WAITING: "/waiting",
  QUEUE: "/queue",
  CODE: "/code",
  CHARACTER: "/character",
  PLAY: "/play",
  EXPIRED: "/expired",
  ERROR: "/error",
} as const;

export const path = {
  home: (artist: Artist): string => `/${artist}`,
  waiting: (artist: Artist): string => `/${artist}${ROUTE_PATHS.WAITING}`,
  waitingQueue: (artist: Artist): string => `/${artist}${ROUTE_PATHS.QUEUE}`,
  code: (artist: Artist): string => `/${artist}${ROUTE_PATHS.CODE}`,
  character: (artist: Artist): string => `/${artist}${ROUTE_PATHS.CHARACTER}`,
  play: (artist: Artist): string => `/${artist}${ROUTE_PATHS.PLAY}`,
  expired: (artist: Artist): string => `/${artist}${ROUTE_PATHS.EXPIRED}`,
  error: (artist: Artist): string => `/${artist}${ROUTE_PATHS.ERROR}`,
} as const;

export const PATHS = {
  DEFAULT: "/",
  ...ROUTE_PATHS,
} as const;
